/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'tools-location': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M10 6.25A1.875 1.875 0 1110 10a1.875 1.875 0 010-3.75zM10 5a3.125 3.125 0 100 6.25A3.125 3.125 0 0010 5zm0-2.5a5.55 5.55 0 015.625 5.444 5.29 5.29 0 01-1.119 3.256L10 17.788 5.531 11.25a5.294 5.294 0 01-1.156-3.306A5.55 5.55 0 0110 2.5zm0-1.25a6.788 6.788 0 00-6.875 6.694A6.581 6.581 0 004.5 11.963L10 20l5.5-8.037a6.581 6.581 0 001.375-4.02A6.787 6.787 0 0010 1.25z"/>'
  }
})
